import React from "react";
import Title from "./Title";

const Services = () => {
  return (
    <Title
      brand="Services"
      images="https://preview.colorlib.com/theme/narosundar/assets/img/hero/hero2.jpg.webp"
    />
  );
};

export default Services;
